<template>
  <div>
    <main-image-section />
    <div class="container">
      <div class="row">
        <div class="col text-center font-default">
          <div class="block p-t">
            <h2 class="fnt font-deco">
              {{ $t("SHARE_PAGE__TITLE") }}
            </h2>
            <p v-if="customMsg" v-html="customMsg"></p>
            <p v-html="$t('SHARE_PAGE__INTRO')"></p>
          </div>

          <div class="content-narrow">
            <div class="block p-t">
              <el-button
                v-if="supportShareAPI"
                type="info"
                @click="shareAPI"
                class="w100"
              >
                {{ $t("SHARE_PAGE__SHARE_CONTEST") }}
                <i class="fas fa-share"></i>
              </el-button>

              <social-sharing
                v-else
                :url="url"
                :title="$t('SHARED__APP_TITLE')"
                :description="$t('SHARED__APP_DESCRIPTION')"
                twitter-user="tuango"
                inline-template
              >
                <div>
                  <network network="facebook">
                    <a class="c-share-btn c-share-btn--fb" href="javascript:;"
                      ><i class="fab fa-facebook-f"></i
                      >{{ $t("SHARE_PAGE__FACEBOOK_BTN") }}</a
                    >
                  </network>
                  <network network="twitter">
                    <a class="c-share-btn c-share-btn--tw" href="javascript:;"
                      ><i class="fab fa-twitter"></i
                      >{{ $t("SHARE_PAGE__TWITTER_BTN") }}</a
                    >
                  </network>
                </div>
              </social-sharing>
            </div>

            <div class="block p-t share-link">
              <p>{{ $t("SHARE_PAGE__SHARE_LINK_TXT") }}</p>
              <el-input class="copy-url-input" :value="url" readonly>
                <el-button
                  slot="append"
                  type="info"
                  class="copy-url-button no-anim"
                  :aria-label="$t('C2020__COPY')"
                  :title="$t('C2020__COPY')"
                  @click="copyShareUrl"
                >
                  <i class="far fa-copy"></i>
                </el-button>
              </el-input>
            </div>
          </div>

          <div class="block">
            <h4 class="fnt font-deco" v-html="$t('SHARE_PAGE__MERCI')"></h4>
          </div>

          <div class="content-narrow">
            <div class="block p-b">
              <el-button @click="gotoTuango" type="primary" class="w100">
                {{ $t("SHARE_PAGE__VISIT_TUANGO_BTN") }}
              </el-button>
            </div>

            <div class="block p-b">
              <el-button
                v-if="token"
                @click="gotoMyPlane"
                type="primary"
                class="w100"
              >
                {{ $t("SHARE_PAGE__MY_PLANE_BTN") }}
                <i class="fas fa-plane"></i>
              </el-button>
            </div>
          </div>

          <div class="content-narrow">
            <a :href="extrernalLink" class="external_link" target="_blank">
              {{
                destination && destination.externalLinkFr
                  ? $t("SHARED__VISIT_WINGBUDDY_DESTINATION")
                  : $t("SHARED__VISIT_WINGBUDDY")
              }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex"
import SocialSharing from "vue-social-sharing"

import MainImageSection from "../components/Layout/MainImageSection"
import UserService from "@/services/api/UserService"
import to from "await-to-js"

const { mapGetters } = createNamespacedHelpers("app")
const userService = new UserService()

export default {
  name: "Share",
  components: {
    MainImageSection,
    SocialSharing
  },
  props: {
    customMsg: {
      type: String
    }
  },
  data() {
    return {
      token: null,
      userId: null,
      destination: null,
      referralToken: null
    }
  },
  computed: {
    ...mapGetters(["utmQs"]),
    baseUrl() {
      return (
        "https://" +
        process.env[`VUE_APP_DOMAIN_${this.$i18n.locale.toUpperCase()}`]
      )
    },
    url() {
      if (!this.referralToken) {
        return this.baseUrl
      }

      return `${this.baseUrl}?r=${encodeURIComponent(this.referralToken)}`
    },
    shareData() {
      return {
        title: this.$t("SHARED__APP_TITLE"),
        text: this.$t("SHARED__APP_DESCRIPTION"),
        url: this.url
      }
    },
    supportShareAPI() {
      return !!navigator.share
    },
    extrernalLink() {
      const language = this.$i18n.locale === "fr" ? "Fr" : "En"
      let url =
        this.$i18n.locale === "fr"
          ? "https://www.wingbuddy.com/voyages"
          : "https://www.wingbuddy.com"

      if (this.destination && this.destination.externalLinkFr) {
        url = this.destination["externalLink" + language]
      }

      return url
    }
  },
  methods: {
    gotoMyPlane() {
      this.$router.push({
        name: "status",
        query: { t: this.token, u: this.userId }
      })
    },
    gotoTuango() {
      window.location.assign(
        `https://www.tuango.ca/${this.$i18n.locale}/category/escapades/?${this.utmQs}`
      )
    },
    gotoIDC() {
      const url =
        this.$i18n.locale === "fr"
          ? "https://www.idcdermo.com/ca_fr/?utm_campaign=concours_solis&utm_medium=affiliate&utm_source=tuango&utm_content=idc_dermo"
          : "https://www.idcdermo.com/ca_en/?utm_campaign=concours_solis&utm_medium=affiliate&utm_source=tuango&utm_content=idc_dermo"
      window.location.assign(url)
    },
    async copyShareUrl() {
      try {
        if (navigator.clipboard) {
          await navigator.clipboard.writeText(this.url)
        } else {
          this.copyShareUrlFallback()
        }

        this.showCopiedMessage()
      } catch (err) {
        if (err) {
          this.copyShareUrlFallback()
        }
        this.showCopiedMessage()
      }
    },
    showCopiedMessage() {
      this.$message({
        customClass: "copy-message",
        duration: 3000,
        message: this.$t("C2020__COPIED"),
        offset: 88,
        type: "success"
      })
    },
    copyShareUrlFallback() {
      const textarea = document.createElement("textarea")
      textarea.value = this.url
      textarea.setAttribute("readonly", "")
      textarea.style.position = "absolute"
      textarea.style.left = "-9999px"
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand("copy")
      document.body.removeChild(textarea)
    },
    async shareAPI() {
      try {
        await navigator.share(this.shareData)
      } catch (err) {
        if (err && err.name !== "AbortError") {
          this.$message({
            message: this.$t("SHARED__SERVER_ERROR"),
            type: "error"
          })
        }
      }
    }
  },

  async created() {
    this.token = this.$route.query.t
    this.userId = this.$route.query.u

    if (!this.token || !this.userId) {
      return
    }

    const [, user] = await to(userService.get(this.userId, this.token))

    if (user && user.destination) {
      this.destination = user.destination
    }

    if (user && user.referralToken) {
      this.referralToken = user.referralToken
    }
  }
}
</script>

<style scoped>
.external_link {
  font-size: 18px;
  text-decoration: underline;
}

.share-link {
  text-align: left;
}

.share-link p {
  text-align: center;
}
</style>

<style>
.share-link .copy-url-input.el-input-group {
  align-items: stretch;
  display: flex;
  height: 45px;
  width: 100%;
}

.share-link .copy-url-input > .el-input__inner {
  border-right: none;
  box-sizing: border-box;
  flex: 1 1 auto;
  height: 45px;
  line-height: 45px;
  min-width: 0;
  width: 100%;
}

.share-link .copy-url-input > .el-input-group__append {
  align-items: stretch;
  background: #3498db;
  border: 0;
  box-sizing: border-box;
  color: #fff;
  display: flex;
  flex: 0 0 60px;
  height: 45px;
  overflow: hidden;
  padding: 0;
  width: 60px;
}

.share-link .copy-url-input .copy-url-button.el-button {
  align-items: center;
  background: #3498db;
  border-color: #3498db;
  color: #fff;
  display: flex;
  font-size: 1.2rem;
  height: 100%;
  justify-content: center;
  margin: 0;
  padding-left: 0;
  padding-right: 0;
  width: 60px;
}

.share-link .copy-url-input .copy-url-button:focus,
.share-link .copy-url-input .copy-url-button:hover {
  background: #5dade2;
  border-color: #5dade2;
  color: #fff;
}

.copy-message.el-message {
  background: #ed6e1f;
  border-color: #ed6e1f;
  box-shadow: 0 8px 20px rgba(64, 74, 79, 0.2);
}

.copy-message .el-message__content,
.copy-message .el-message__icon {
  color: #fff;
  font-size: 1rem;
}
</style>
